import React from "react";
import PageHeader from "../layout/PageHeader";
import { MdEmail } from "react-icons/md";
import { FaPhoneAlt } from "react-icons/fa";
import { IoLocationSharp } from "react-icons/io5";

const Contact = () => {
  const detailContent = [
    {
      icon: <IoLocationSharp />,
      title: "Our Location",
      content: "342/A Brooklyn St, Milson Avenue, New York, USA",
    },
    {
      icon: <MdEmail />,
      title: "Email Us",
      content: "hello@cuex.com ",
      content2: "support@cuex.com",
    },
    {
      icon: <FaPhoneAlt />,
      title: "Phone",
      content: "+44 587 154765 ",
      content2: "+55 576 234532",
    },
  ];

  return (
    <div className="contact_page">
      <PageHeader title="Contact Us" crumb="Contact" />
      <div className="container px-sm-2 px-4 section-padding">
        <div className="row g-4">
          {detailContent.map((element, index) => {
            return (
              <div className="col-lg-4 col-sm-6" key={index} data-aos='zoom-in'>
                <div className="detail_card d-flex align-items-start transition p-4 bg-white shadow-sm ">
                  <div className="detail_icon">{element.icon}</div>
                  <div className="detail_content ">
                    <h5 className="fw-800 text-black mb-4">{element.title}</h5>
                    <p className="text-color mb-2">{element.content}</p>
                    <p className="text-color mb-0">{element.content2}</p>
                  </div>
                </div>
              </div>
            );
          })}

          {/* FORM  SECTION */}
          <div className="col-lg-8">
            <div className="form_section_start shadow-sm p-4 bg-white">
              <div className="row p-sm-4 p-3">
                <div className="col-sm-6 mb-4 " data-aos='fade-up' >
                  <div className="contact_form">
                    <input
                      type="text"
                      className="form-control rounded-0 p-3"
                      placeholder="Name*"
                    />
                  </div>
                </div>
                <div className="col-sm-6 mb-4 " data-aos='fade-up' >
                  <div className="contact_form">
                    <input
                      type="email"
                      className="form-control rounded-0 p-3"
                      placeholder="Email*"
                    />
                  </div>
                </div>
                <div className="col-sm-6 mb-4 " data-aos='fade-up' >
                  <div className="contact_form">
                    <input
                      type="phone"
                      className="form-control rounded-0 p-3"
                      placeholder="Phone*"
                    />
                  </div>
                </div>
                <div className="col-sm-6 mb-4 " data-aos='fade-up' >
                  <div className="contact_form">
                    <input
                      type="text"
                      className="form-control rounded-0 p-3"
                      placeholder="Subject*"
                    />
                  </div>
                </div>
                <div className="col-12" data-aos='fade-up'> 
                  <div className="contact_form">
                    <textarea
                      className="form-control rounded-0"
                      style={{ resize: "none" }}
                      placeholder="Your Messages"
                      rows="5"
                    ></textarea>
                    <button className="mt-5 btn btn-primary" data-aos='zoom-in'>
                      Send Message
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* MAP SECTION */}

          <div className="col-lg-4" data-aos='zoom-in'>
            <div className="map_section">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1973686.8011324883!2d70.99944709379231!3d33.8322328173864!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38dfbfd07891722f%3A0x6059515c3bdb02b6!2sIslamabad%2C%20Islamabad%20Capital%20Territory%2C%20Pakistan!5e0!3m2!1sen!2s!4v1703002622665!5m2!1sen!2s"
                style={{width : '100%' , height : '60vh'}}
                title="this is a map"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
